import React, { useContext } from "react";
import { DailyMotionVideoTeaserEntry } from "../helper/interfaces";
import { TeaserData } from "./teaser";
import { CmpIdentifier } from "../helper/enums";
import { ConsentContext } from "../provider/ConsentContextProvider";

declare global {
  interface Window {
    dailymotion: any;
  }
}

export default function TeaserDailyMotionVideo(data: TeaserData) {
  const teaser = data.teaser as DailyMotionVideoTeaserEntry;
  const providerId = "xbpb0";
  const videoId = teaser.providerId;
  const divId = `my-dailymotion-player-${videoId}`;

  const { getProviderId } = useContext(ConsentContext);
  const cmpVendorId = getProviderId(CmpIdentifier.DailyMotion);
  
  return (
    <React.Fragment>
      {cmpVendorId &&
        <div className="video-frame">
          <span
            id={teaser.providerId}
            className="cmplazyload video-dailymotion"
            data-cmp-vendor={cmpVendorId}
            data-cmp-preview="100%x350"
        >
          <div id={divId}>
            <iframe
              title="DailyMotion Video"
              frameBorder="0"
              className="video-dailymotion-iframe"
              src={`https://geo.dailymotion.com/player/${providerId}.html?video=${videoId}`}
              allowFullScreen
              allow="fullscreen; picture-in-picture"
            ></iframe>
          </div>
        </span>
      </div>
      }
    </React.Fragment>
  );
  // <Dailymotion playsinline={true} video={teaser.providerId} width={"100%"}/>
}
